module.exports = __webpack_public_path__ + "static/media/cancel-icon.9e22d16e.svg";